import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgQrCode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: props.width ?? props.size ?? "1em",
	height: props.height ?? props.size ?? "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1600000785",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [/* @__PURE__ */ _jsxs("g", {
					id: "Group_2",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M13.6016 18.9996H18.5016C18.7777 18.9996 19.0016 18.7758 19.0016 18.4996V13.5996",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round"
					}), /* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M1 13.5996V18.4996C1 18.7758 1.22386 18.9996 1.5 18.9996H6.4",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round"
					})]
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group_3",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M6.4 1H1.5C1.22386 1 1 1.22386 1 1.5V6.4",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round"
					}), /* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M19.0016 6.4V1.5C19.0016 1.22386 18.7777 1 18.5016 1H13.6016",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round"
					})]
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M15 5H11V9H15V5Z",
				stroke: "currentColor",
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M9 11H5V15H9V11Z",
				stroke: "currentColor",
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_4",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_7",
						d: "M15 15V13H13",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_8",
						d: "M11 11V12",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_9",
						d: "M14 11H13",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_10",
						d: "M13 15H11V14",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_5",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_11",
						d: "M5 5V7H7",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_12",
						d: "M9 9V8",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_13",
						d: "M5 9H7",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_14",
						d: "M7 5H9V7V8",
						stroke: "currentColor",
						strokeMiterlimit: 10,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_15",
				d: "M12.5 7C12.5 7.27614 12.7239 7.5 13 7.5C13.2761 7.5 13.5 7.27614 13.5 7C13.5 6.72386 13.2761 6.5 13 6.5C12.7239 6.5 12.5 6.72386 12.5 7Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_16",
				d: "M10.5 14C10.5 14.2761 10.7239 14.5 11 14.5C11.2761 14.5 11.5 14.2761 11.5 14C11.5 13.7239 11.2761 13.5 11 13.5C10.7239 13.5 10.5 13.7239 10.5 14Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_17",
				d: "M6.5 13C6.5 13.2761 6.72386 13.5 7 13.5C7.27614 13.5 7.5 13.2761 7.5 13C7.5 12.7239 7.27614 12.5 7 12.5C6.72386 12.5 6.5 12.7239 6.5 13Z",
				fill: "currentColor"
			})
		]
	})
});
export default SvgQrCode;
